import { useMemo } from 'react';
import { Location, useLocation } from 'react-router-dom';

const useOnLocationChange = (callback: (location: Location) => boolean) => {
  const location = useLocation();
  return useMemo(() => callback(location), [callback, location]);
};

export default useOnLocationChange;
